import _ from 'lodash';
/**
 * @class AppState
 * @description The AppState class is used to manage and interact with the state of the application.
 */
class AppState {
    /**
     * @constructor
     * @description Sets the initial state for the application.
     * @memberof AppState
     * @return {void}
     */
    constructor() {
        this.state = {
            planId: '',
            planType: '',
            drupalJsObjects: {
                Drupal: {},
                Window: {},
                context: null,
                settings: {},
            },
            selectedPlanData: Promise.resolve({
                jsonapi: {},
                data: [],
                included: [],
                links: {}
            }),
            salesId: '',
            token: '',
            addressConfirmed: '',
            addressCheckProgress: '',
            mutableOptions: [],
            slabFibreServiceType: '',
            serviceFunnelPackage: {
                address: {
                    Composite: '',
                    LevelTypeCode: '',
                    LevelNumberSuffix: '',
                    LevelNumber: '',
                    Postcode: '',
                    Suburb: '',
                    StateName: '',
                    StreetType: '',
                    StreetName: '',
                    StreetSuffixCode: '',
                    StreetNumber2: '',
                    StreetNumber1Suffix: '',
                    StreetNumber: '',
                    UnitTypeCode: '',
                    UnitSuffix: '',
                    UnitNumber: '',
                },
                availableSelections: [],
                bundles: [],
                internetSelection: {
                    planIdentifier: '',
                    planName: '',
                    upload: '',
                    download: '',
                    price: '',
                    showSpeedUpgrade: false,
                    showFibreUpgrade: false,
                    modemCost: '',
                    discount: {
                        discountPrice: 0,
                        discountAmount: '',
                        discountType: '',
                    },
                },
                hfcSelfAndRspProfessionalInstallEligible: false,
                isCoat: false,
                newDevelopmentsChargeApplies: false,
                provider: 1,
                serviceType: 1,
                showServiceTransfer: false,
                serviceabilityClass: 0,
            },
            onePlatformData: {
                externalId: '',
                serviceQualificationItem: [{
                        service: {
                            place: [{
                                    id: '',
                                    role: 'Service Address'
                                }]
                        }
                    }],
                relatedParty: [{
                        '@type': 'PartyType',
                        id: 'iPrimus',
                        role: 'brand'
                    }],
                planPromoCode: '',
                validPromoData: ''
            }
        };
    }
    /**
     * @function set
     * @description This method allows to update the value of a specific key in the state object.
     * @param {string} key - The key to set the value for.
     * @param {*} value - The value to be set.
     * @returns {void}
     */
    set(key, value) {
        _.set(this.state, key, value);
    }
    /**
     * @function get
     * @description This method provides access to the value of a specified key from the state object.
     * @param {string} key - The key to look for in the state object.
     * @return {*} - The value associated with the specified key, or undefined if the key does not exist.
     */
    get(key) {
        return _.get(this.state, key);
    }
}
// Create an instance of the AppState
const appState = new AppState();
export default appState;
